import SiteLayout from "@/Layouts/SiteLayout"
import { Seo } from "@/Components/Seo"
import { LandingFirearmsContainer } from "@/Components/Container/LandingFirearmsContainer"

export default function LandingFirearms({
    title,
    description,
    schemas,
    brands,
}) {
    return (
        <>
            <Seo title={title} description={description} schemas={schemas} />

            <SiteLayout>
                <LandingFirearmsContainer />
            </SiteLayout>
        </>
    )
}
